import http from '../http'

export default {
    /**
     * Actualiza el rol.
     * @param {int} usuario
     * @param {int} rol
     * @returns {Promise}
     */
    update(usuario, rol) {
        return http.put(`usuarios/${usuario}/roles/${rol}`)
    },
}